/**
 * The disappear effect. {@link fadeAt} is the pure 0→1 progress ramp driving it; {@link DiceStage}
 * multiplies each dying die's solid + edge-line material opacity by `1 - fadeAt(...)` across the
 * linger window, so the die fades out.
 */

/**
 * Pure fade-progress ramp: 0 at the start of the linger window, 1 once `lingerMs` has elapsed.
 * Clamped both ends (negative `elapsedMs`, or `elapsedMs` past `lingerMs`) so callers can feed it
 * a raw `now - settledAt` without their own guarding. Extracted as a pure function so the
 * mechanism is headlessly testable independent of the (untestable-without-a-GPU) render loop.
 */
export function fadeAt(elapsedMs: number, lingerMs: number): number {
  if (lingerMs <= 0) return elapsedMs > 0 ? 1 : 0;
  return Math.min(Math.max(elapsedMs / lingerMs, 0), 1);
}
